import * as z from "zod/v4";

export const saveAeoAssistantThread = {
  name: "saveAeoAssistantThread" as const,
  input: z.object({
    threadId: z.string(),
    saved: z.boolean().optional(),
    title: z.string().max(60).optional(),
  }),
  output: z.object({ success: z.boolean() }),
};
